// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"f1ba6f47","230":"cfe375ae","357":"537c3e98","453":"64b9e06f","534":"8e8185fb","584":"0d089983","596":"212b03e9","626":"11b2015d","674":"8587bcc7","738":"a3540f27","918":"112c7459"}[chunkId] + ".chunk.js";
};